module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightlightsnow@2-d5bc6480add6662a7dffbd095c9d80a4.png";